import type React from 'react';
import { useTranslation } from 'react-i18next';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

/**
 * The picker while its list is unknown.
 *
 * The heading stays and so does the shape of the search field: what is unknown
 * is which operations exist, not that there is a search field. Five placeholder
 * rows because a role-filtered list usually has several — one would suggest the
 * picker holds a single choice, which is a different screen entirely.
 */
export const CommandPickerSkeleton: React.FC = () => {
    const { t } = useTranslation('pages');

    return (
        <section
            aria-label={t('operations.record.picker.title')}
            className="flex flex-col gap-3 rounded-2xl border border-separator bg-surface p-4"
            {...getNodeTestIdProp('operations-record-picker-skeleton')}
        >
            <span className="text-sm font-medium text-foreground">
                {t('operations.record.picker.step')}
            </span>
            <div className="h-10 w-full animate-pulse rounded-xl bg-surface-secondary" />
            <ul className="flex flex-col gap-1">
                {[0, 1, 2, 3, 4].map((index) => (
                    <li className="flex flex-col gap-1.5 px-3 py-2" key={index}>
                        <div className="h-4 w-40 animate-pulse rounded bg-surface-secondary" />
                        <div className="h-3 w-28 animate-pulse rounded bg-surface-secondary" />
                    </li>
                ))}
            </ul>
        </section>
    );
};
